import { postResource } from './handleFetch.service';

export const register = async (name, surname, email, password, ip, sessionId = null, timezone = null, captchaToken = null) => await postResource('users/register', {
  email, password, name, surname, ip, sessionId, timezone, captchaToken,
});

export const login = async (email, password, ip, sessionId = null, timezone = null) => {
  const data = await postResource('users/login', {
    email, password, ip, sessionId, timezone,
  });
  return data;
};

// Exchange a magic-link token for a session. Returns the same shape as login().
export const magicLogin = async (id, token) => {
  const data = await postResource('users/magic-login', { id, token });
  return data;
};

export const changeName = async (name, token) => {
  const data = await postResource('users/change_credentials/name', { name }, token);
  return data;
};

export const changeSurname = async (surname, token) => {
  const data = await postResource('users/change_credentials/surname', { surname }, token);
  return data;
};

// Needs the current password. The reply carries a fresh access_token: the change
// revokes every other session, and the caller continues on the new token.
// Never replayed - a retried change would hit "password is equal current password".
export const changePassword = async (currentPassword, password, token) => postResource(
  'users/change_credentials/password',
  { currentPassword, password },
  token,
  { maxRetries: 0 },
);

export const changeEmail = async (email, token) => {
  await postResource('users/change_credentials/email', { email }, token);
};

export const setCookies = () => {
};

/**
 * True when the token is unusable: expired, or not a readable JWT at all.
 *
 * This used to throw on anything that was not a well-formed JWT — a truncated
 * value, a leftover from an older auth scheme, an empty string. Its only caller
 * runs inside a try/catch, so the throw was swallowed and took the rest of that
 * block with it (the cart refresh never ran) while the caller carried on as if
 * the session were fine.
 *
 * An unreadable token cannot be trusted and the backend would reject it anyway,
 * so "unreadable" now answers the same as "expired" — but deliberately, and in a
 * form the caller can act on rather than as an exception.
 */
export const isTokenExpired = (token) => {
  try {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    if (!Number.isFinite(expiry)) return true;
    return (Math.floor((new Date()).getTime() / 1000)) >= expiry;
  } catch {
    return true;
  }
};
